import React from 'react';
import styled from 'styled-components';

import { ButtonTs } from '@lt/components';
import { Meal } from '@lt/components/icons-react/userflow';

// import type { MealType } from '@lt/api/dist/methods/search/types';

interface IHotelRoomMealInfo {
  // hotelRoomMealTypes: Array<MealType>;
  selectedMealType: string;
  // selectMealType: any;
  redirectToHotelPage: (nights_count?: number) => void;
}

const HotelRoomMealInfo = (props: IHotelRoomMealInfo): JSX.Element => {
  // const { hotelRoomMealTypes, selectedMealType, selectMealType, redirectToHotelPage } = props;
  const { selectedMealType, redirectToHotelPage } = props;

  return (
    <HotelRoomOptionsContainer>
      {/* {hotelRoomMealTypes[0] && ( */}
      <OptionContainer
        variant="functional"
        $isSelected
        // $isSelected={selectedMealType === hotelRoomMealTypes[0].id}
        // onClick={() => selectMealType(hotelRoomMealTypes[0].id)}
      >
        {/* <Meal width={10} /> {hotelRoomMealTypes[0].description} */}
        <Meal width={10} /> {selectedMealType}
      </OptionContainer>
      {/* )} */}
      {/* {hotelRoomMealTypes[1] && (
        <OptionContainer
          variant="functional"
          className="second-option"
          $isSelected={selectedMealType === hotelRoomMealTypes[1].id}
          onClick={() => selectMealType(hotelRoomMealTypes[1].id)}
        >
          <Meal width={10} /> {hotelRoomMealTypes[1].description}
        </OptionContainer>
      )} */}
      <StyledButton variant="functional" onClick={() => redirectToHotelPage(undefined)}>
        ещё
      </StyledButton>
    </HotelRoomOptionsContainer>
  );
};

const HotelRoomOptionsContainer = styled.div`
  margin-top: 4px;
  margin-bottom: 8px;
  font-size: 12px;
  font-weight: 700;
  @media (max-width: 459px) {
    .options-count {
      display: none;
    }
    .second-option {
      display: none;
    }
  }
`;

const OptionContainer = styled(ButtonTs)<{ $isSelected: boolean }>`
  // повышаем specificity чтобы при многократном использовании компонентов,
  // в разных виджетах на одной странице,
  // первичные стили не перетирали переопределенные
  && {
    display: inline-block;
    margin-right: 8px;
    cursor: default;
    ${({ $isSelected }) =>
      !$isSelected &&
      `color: #007aff;
    cursor: pointer;
    font-weight: 400 !important;
  svg > path {
    stroke: #007aff;
  }`}
  }
`;

const StyledButton = styled(ButtonTs)`
  // повышаем specificity чтобы при многократном использовании компонентов,
  // в разных виджетах на одной странице,
  // первичные стили не перетирали переопределенные
  && {
    color: #007aff;
    font-weight: 400 !important;
  }
`;

export default HotelRoomMealInfo;
